import { createApi } from '@reduxjs/toolkit/query/react';
import { ReducerPaths } from '../../constants/reducerPaths';
import { baseQuery } from '../../utils/baseQuery';
import { getCandidatePositionHistory } from './queries';

export const candidatePositionStatusApi = createApi({
  reducerPath: ReducerPaths.CANDIDATE_POSITION_STATUS,
  baseQuery,
  tagTypes: ['CandidatePositionHistory'],
  endpoints: (builder) => ({
    getCandidatePositionHistory: getCandidatePositionHistory(builder),
  }),
});

export const {
  useGetCandidatePositionHistoryQuery,
  useLazyGetCandidatePositionHistoryQuery,
} = candidatePositionStatusApi;
